/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  GetAreaDetail,
  GetDelayedPointDetail,
  GetSettledPointsDetail,
  GetRegularPointsDetail,
} from "../../../graphql/sourceDetail";
import {
  importFcDetail,
  importDelayedPoints,
  importSettledPoints,
  importRegularPoints,
} from "../../../redux/actions/fcDetail";
import { ActionByOption, GetDropdownOptions } from "./rowDetail/functions";
import { useBlockedFeatures } from "src/hooks/useBlockedFeatures";
import { toMoney } from "../../../utils/formatter";
import CardDetail from "./cardDetail";
import FilterData from "./filterData";
import LabelData from "./label";
import TableDetail from "./tableDetail";
import { Dropdown } from "semantic-ui-react";

import "./areaDetail.scss";

export default function AreaDetail({ editData }) {
  const dispatch = useDispatch();
  const { abonarBlocked } = useBlockedFeatures();
  const { areaName, fcData } = useSelector((state) => state.fcDetail);
  const { updateNeeded } = useSelector((state) => state.flujocaja);
  const { openSidebar } = useSelector((state) => state.openSidebar);
  const [totalSelected, setTotalSelected] = useState({});
  const [regularPointsView, setRegularPointsView] = useState(true);
  const [delayedPointsView, setDelayedPointsView] = useState(false);
  const [settledPointsView, setSettledPointsView] = useState(false);
  const [filterPoint, setFilterPoint] = useState();
  const [selected, setSelected] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [areaSelected, setAreaSelected] = useState(areaName);

  // const detail = GetAreaDetail(
  //   fcData?.companyId,
  //   fcData?.areaId,
  //   fcData?.startDate,
  //   fcData?.endDate,
  //   fcData?.useDelayesd,
  //   fcData?.currencyType,
  //   fcData?.isOld
  // );

  const delayedPoints = GetDelayedPointDetail(
    fcData?.companyId,
    fcData?.areaId,
    fcData?.startDate,
    fcData?.endDate,
    fcData?.useDelayesd
  );

  const settledPoints = GetSettledPointsDetail(
    fcData?.companyId,
    fcData?.areaId,
    fcData?.startDate,
    fcData?.endDate,
    fcData?.useDelayesd,
    fcData?.isOld
  );

  const regularPoints = GetRegularPointsDetail(
    fcData?.companyId,
    fcData?.areaId,
    fcData?.startDate,
    fcData?.endDate,
    fcData?.useDelayesd
  );

  const getDropdownOptions = GetDropdownOptions(
    settledPointsView,
    areaName,
    selected,
    abonarBlocked,
  );

  const dataToShow = regularPointsView
    ? regularPoints?.data?.AreaDetail?.regularPoints?.points
    : delayedPointsView
    ? delayedPoints?.data?.AreaDetail?.delayedPoints?.points
    : settledPoints?.data?.AreaDetail?.settledPoints?.points;

  const selectedOption = (value) => {
    ActionByOption(
      dispatch,
      value,
      selected,
      editData?.cashflowAreaId,
      totalSelected,
      editData,
      abonarBlocked,
    );
  };

  const changeDetail = (card) => {
    if (!regularPointsView && card === "regularPoints") {
      setRegularPointsView(true);
      setDelayedPointsView(false);
      setSettledPointsView(false);
    }
    if (!delayedPointsView && card === "delayedPoints") {
      setRegularPointsView(false);
      setDelayedPointsView(true);
      setSettledPointsView(false);
    }
    if (!settledPointsView && card === "settledPoints") {
      setRegularPointsView(false);
      setDelayedPointsView(false);
      setSettledPointsView(true);
    }
    setTotalSelected({});
    setFilterPoint("");
    setSelected([]);
  };

  useEffect(() => {
    setAreaSelected(areaName);
    if (areaSelected.name !== areaName.name) {
      setSelected([]);
      setTotalSelected({});
    }
  }, [areaName]);

  // useEffect(() => {
  //   if (detail?.data && !detail?.fetching) {
  //     dispatch(importFcDetail(detail.data.AreaDetail));
  //   }
  //   if (delayedPoints?.data && !delayedPoints?.fetching) {
  //     dispatch(importDelayedPoints(delayedPoints.data.AreaDetail));
  //   }
  //   if (settledPoints?.data && !settledPoints?.fetching) {
  //     dispatch(importSettledPoints(settledPoints.data.AreaDetail));
  //   }
  //   if (regularPoints?.data && !regularPoints?.fetching) {
  //     dispatch(importRegularPoints(regularPoints.data.AreaDetail));
  //   }
  // }, [
  //   detail?.data,
  //   detail?.fetching,
  //   delayedPoints?.data,
  //   delayedPoints?.fetching,
  //   settledPoints?.data,
  //   settledPoints?.fetching,
  //   regularPoints?.data,
  //   regularPoints?.fetching,
  //   fcData,
  // ]);

  // useEffect(() => {
  //   if (updateNeeded?.value) {
  //     detail?.reExecuteQuery({ requestPolicy: "network-only" });
  //     delayedPoints?.reExecuteQuery({ requestPolicy: "network-only" });
  //     settledPoints?.reExecuteQuery({ requestPolicy: "network-only" });
  //     regularPoints?.reExecuteQuery({ requestPolicy: "network-only" });
  //     setSelected([]);
  //     setTotalSelected({});
  //   }
  // }, [updateNeeded]);

  // useEffect(() => {
  //   detail?.reExecuteQuery({ requestPolicy: "network-only" });
  // }, []);

  return <></>
  // return (
  //   <div className="detailContainer">
  //     <CardDetail
  //       detail={detail}
  //       areaName={areaName}
  //       changeDetail={changeDetail}
  //     />
  //     <hr style={{ color: "lightgrey" }} />
  //     <div className="filterTotalOptions">
  //       <div>
  //         <FilterData
  //           label={"Buscar"}
  //           placeholder={"Buscar..."}
  //           value={filterPoint}
  //           onChange={setFilterPoint}
  //         />
  //       </div>
  //       <div>
  //         <LabelData
  //           label={"Total Seleccionado"}
  //           data={totalSelected.amount ? toMoney(totalSelected?.amount) : "$ 0"}
  //         />
  //       </div>
  //       <div
  //         style={{
  //           display: "flex",
  //           alignItems: "center",
  //           marginTop: "15px",
  //           minWidth: "150px",
  //           maxWidth: "160px",
  //         }}
  //       >
  //         <Dropdown text="Opciones" fluid selection>
  //           <Dropdown.Menu>
  //             {selected?.length > 0
  //               ? getDropdownOptions?.map((option) => {
  //                   return (
  //                     <Dropdown.Item
  //                       value={option?.value}
  //                       onClick={(e, data) => selectedOption(data?.value)}
  //                     >
  //                       {option?.text}
  //                     </Dropdown.Item>
  //                   );
  //                 })
  //               : []}
  //           </Dropdown.Menu>
  //         </Dropdown>
  //       </div>
  //     </div>
  //     <div className="containerInnerTableFcDetail">
  //       <TableDetail
  //         data={dataToShow}
  //         openSidebar={openSidebar}
  //         loading={regularPoints.fetching}
  //         filterPoint={filterPoint}
  //         setSelected={setSelected}
  //         selected={selected}
  //         totalSelected={totalSelected}
  //         setTotalSelected={setTotalSelected}
  //         setSelectAll={setSelectAll}
  //         settledPointsView={settledPointsView}
  //       />
  //     </div>
  //   </div>
  // );
}
